<template>
  <div class="container">
    <Breadcrumb :list="breadList" />
    <NavView v-model="filter"></NavView>
    <div class="search">
      <div class="left">
        <div style="cursor: pointer;" :class="{'active': filter.isSort === 1}" @click="changeSort">
          <span>最新</span>
          <img src="@/assets/images/icon-sort-active.png" v-if="filter.isSort === 1" alt="">
          <img src="@/assets/images/icon-sort.png" v-else alt="">
        </div>
        <!-- <div>
          <span>热门</span>
          <img src="@/assets/images/icon-sort-static.png" alt="">
        </div> -->
      </div>
      <div class="right">
        <el-input v-model="filter.name" @keyup.enter.native="reset" prefix-icon="el-icon-search" class="search-input">
          <el-button slot="suffix" @click="reset">搜索</el-button>
        </el-input>
      </div>
    </div>
    <div class="list">
      <List :list="list"></List>
    </div>
    <div class="page">
      <span class="totalPage">共{{Math.ceil(total/10)}}页</span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="filter.page"
        :page-size="filter.limit"
        layout=" prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import List from './list'
import NavView from './nav'
import Breadcrumb from '@/components/breadcrumb.vue'
import { getClassListPage } from '@/api/face'
export default {
  components: {
    List,
    NavView,
    Breadcrumb
  },
  data () {
    return {
      breadList: [
        {
          label: '面授培训',
          path: '/faceList'
        }
      ],
      filter: {
        page: 1,
        limit: 10,
        name: '',
        isSort: 1,
        faceClassId: null,
        year: null,
        period: null
      },
      total: 0,
      list: []
    }
  },
  created () {
    this.getClassListPage()
  },
  methods: {
    async getClassListPage () {
      const res = await getClassListPage(this.filter)
      this.total = +res.data.total
      this.list = res.data.records
    },
    changeSort () {
      this.filter.isSort = this.filter.isSort === 1 ? 2 : 1
      this.reset()
    },
    reset () {
      this.filter.page = 1
      this.filter.limit = 10
      this.getClassListPage()
    },
    handleCurrentChange (v) {
      this.filter.page = v
      this.getClassListPage()
    },
    handleSizeChange (v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getClassListPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1300px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 50px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
  padding-bottom: 100px;
}
.search{
  display: flex;
  align-items: center;
  margin-bottom: 22px;
  .left{
    padding-left: 23px;
    display: flex;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    div{
      margin-right: 30px;
      width: 70px;
      height: 22px;
      text-align: center;
      img{
        width: 20px;
        vertical-align: middle;
      }
      span{
        vertical-align: middle;
      }
      &.active{
        color: #fff;
        background: linear-gradient(90deg, #0F59BE 0%, #4A6EEF 100%);
        border-radius: 11px;
      }
    }
  }
  .right{
    margin-left: auto;
    padding-right: 24px;
    ::v-deep .search-input{
      input{
        width: 208px;
        height: 28px;
        background: rgba(27, 134, 255, 0.29);
        border: 2px solid #0052D2;
        border-radius: 14px;
      }
      .el-input__prefix{
        .el-input__icon{
          color: #476DED;
          line-height: 28px;
          font-weight: bold;
        }
      }
      .el-input__suffix{
        right: 0;
        button{
          border: 0;
          color: #fff;
          padding: 0;
          width: 51px;
          height: 28px;
          background: linear-gradient(90deg, #1059BF 0%, #476DED 100%);
          border-radius: 14px;
        }
      }
    }
  }
}
.list{
  &:last-child{
    border: 0;
  }
}
.page{
  text-align: center;
  margin-top: 30px;
  ::v-deep .el-pagination{
    display: inline-block;
    .el-icon{
      color: #0753B6;
    }
    .number{
      width: 22px;
      height: 28px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      max-width: none;
      margin: 0 15px;
      display: inline-block;
      &.active{
        background: rgba(10, 101, 219, 0.22);
        border: 1px solid #0753B6;
        border-radius: 5px;
      }
    }
    .el-input{
      margin: 0 5px;
      input{
        width: 46px;
        height: 28px;
        background: rgba(10, 101, 219, 0.22);
        border: 1px solid #0753B6;
        border-radius: 5px;
      }
    }
  }
  .totalPage{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 8px;
  }
}
</style>
